import React from 'react';
import { useTranslation } from 'react-i18next';

const contactCards = [
  {
    icon: '📧',
    label: 'email',
    value: 'jiehengstone@gmail.com',
    link: 'mailto:jiehengstone@gmail.com',
  },
  {
    icon: '📞',
    label: 'phone',
    value: '+86 188 5948 0999',
    link: 'tel:+8618859480999',
  },
  {
    icon: '📍',
    label: 'address',
    value: '中国江苏南通如皋港区东升石材产业园区金石大道109号',
  },
];

const Contact = () => {
  const { t } = useTranslation();
  return (
    <div className="page-container" style={{
      minHeight: '100vh',
      width: '100%',
      position: 'relative',
      background: 'none',
      padding: 0,
      overflow: 'hidden',
      animation: 'fadeInUp 1s',
      animationFillMode: 'both',
    }}>
      {/* 背景图片+遮罩，始终撑满整个页面 */}
      <div style={{
        position: 'absolute',
        top: 0, left: 0, width: '100%', height: '100%',
        zIndex: 0,
        background: `linear-gradient(rgba(30,30,30,0.55), rgba(30,30,30,0.55)), url(/images/project_case_1.jpg) center/cover no-repeat`,
      }} />
      {/* 主体内容卡片 */}
      <div style={{
        position: 'relative',
        zIndex: 1,
        minHeight: 'calc(100vh - 80px)', // 80px for navbar
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 0',
      }}>
        <section className="about-section" style={{
          padding: '3.5rem 0',
          borderRadius: 18,
          margin: '2.5rem 0',
          boxShadow: '0 8px 40px 0 rgba(0,0,0,0.18)',
          background: 'rgba(255,255,255,0.88)',
          maxWidth: 900,
          marginLeft: 'auto',
          marginRight: 'auto',
          backdropFilter: 'blur(4px)',
        }}>
          <div className="about-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3.5rem', padding: '0 2vw' }}>
            <div className="about-text" style={{ flex: '1 1 0', minWidth: 260 }}>
              <h2 style={{ fontSize: '2.2rem', fontWeight: 700, marginBottom: '0.5rem', color: '#222', letterSpacing: '0.01em' }}>{t('contact.title')}</h2>
              <h4 style={{ fontSize: '1.25rem', fontWeight: 500, color: '#bfa14a', marginBottom: '1.2rem', letterSpacing: '0.02em' }}>{t('contact.guide')}</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 18, marginTop: 24 }}>
                {contactCards.map((card) => (
                  <div key={card.label} style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <span style={{ fontSize: 22 }}>{card.icon}</span>
                    <span style={{ fontWeight: 600, color: '#333', minWidth: 60 }}>{card.label === 'address' ? t('contact.address') : t(`contact.${card.label}`)}</span>
                    {card.link ? (
                      <a href={card.link} style={{ color: '#bfa14a', textDecoration: 'underline', fontSize: 15 }}>{card.value}</a>
                    ) : (
                      <span style={{ color: '#bfa14a', fontSize: 15 }}>{card.value}</span>
                    )}
                  </div>
                ))}
              </div>
              <div style={{ color: '#888', fontSize: 16, marginTop: 32, lineHeight: 1.7 }}>{t('contact.description')}</div>
            </div>
            <div className="about-image" style={{ flex: '0 0 260px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src="/images/logo.jpg" alt="Contact Jieheng Stone" style={{ width: 220, height: 220, objectFit: 'contain', borderRadius: 18, boxShadow: '0 4px 24px rgba(191,161,74,0.08), 0 1.5px 8px rgba(0,0,0,0.06)', background: '#fff', padding: '1.5rem' }} />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;

<style>{`
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 40px, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
`}</style> 